import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetLocationRequestConfigsQuery, useUpdateLocationRequestConfigMutation } from '../../../api/locationRequestConfigsApiSlice';
import CollapsableLocationRequestConfig from '../../../components/sdk/CollapsableLocationRequestConfig';
import TreeBorderStructure from '../../../components/TreeBorderStructure';

const PublisherLocationRequestConfig = () => {
  const publisherId = useParams()["publisherId"];
  const {data : locationRequests = {}, isSuccess, refetch} = useGetLocationRequestConfigsQuery(publisherId)
  const { t } = useTranslation();
  const [updateLocationRequestConfig] = useUpdateLocationRequestConfigMutation()

  if (! isSuccess) { return (<></>) }

  return (
    <>
      <TreeBorderStructure>
        <CollapsableLocationRequestConfig
          title={locationRequests.name}
          icon={"publishers"}
          closeBtnText={t('locationRequestConfig.default_config')}
          onSave={updateLocationRequestConfig}
          data={{...locationRequests, publisher_id: publisherId}}/>
        {
          locationRequests.apps && locationRequests.apps.map((app, i) => {
            return (
              <CollapsableLocationRequestConfig
                title={app.name}
                key={i}
                icon={app.os}
                closeBtnText={t('locationRequestConfig.config')}
                onSave={updateLocationRequestConfig}
                data={{...app, publisher_id: publisherId}}/>
            )
          })
        }
      </TreeBorderStructure>
    </>
  )
}

export default PublisherLocationRequestConfig;
